import { render, staticRenderFns } from "./ImgFooter.vue?vue&type=template&id=1edfdbde&scoped=true"
import script from "./ImgFooter.vue?vue&type=script&lang=js"
export * from "./ImgFooter.vue?vue&type=script&lang=js"
import style0 from "./ImgFooter.vue?vue&type=style&index=0&id=1edfdbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edfdbde",
  null
  
)

export default component.exports